import React from "react";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import { AdvancedSearchItems } from "../item-cards";
import useIsAdvancedSearchMobile from "../hooks/useIsAdvancedSearchMobile";

/**
 * Muestra los niveles de lectura de la búsqueda avanzada.
 *
 * @param {object} props
 * @param {object} props.textos
 * @param {object} props.data
 * @param {boolean} props.showTitle
 * @param {Function} props.onClose
 */
export const AdvancedSearchReadingLevels = ({
    textos,
    data,
    showTitle = true,
    onClose,
}) => {
    const history = useHistory();

    const levels = data?.readingLevel || [];

    const isAdvancedSearchMobile = useIsAdvancedSearchMobile();

    const getLevelName = (level) => (
        _.get(textos, level?.name?.translationPath) ||
        level?.name?.defaultValue
    );

    const handleClick = (level) => {
        history.push({
            pathname: "/busqueda",
            search: `?${level?.type}=${level?.id}`,
            state: {
                forceSearchByParams: true,
            },
        });

        onClose && onClose();
    };

    return (
        <section className="advanced-search-reading-levels pb-5 pt-4">

            {showTitle && (
                <h2 className="section-title">
                    {textos?.content?.titulo3 || "Niveles"}
                </h2>
            )}

            <div className="d-sm-flex flex-wrap mt-2">
                {levels.map((level) => (
                    <div
                        key={level.id}
                        className={`d-flex flex-column ${isAdvancedSearchMobile ? "col-md-6 col-lg-4": "col-md-12 px-2"}`}
                    >
                        <AdvancedSearchItems.ReadingLevelCard
                            imgClass={level.imgClass}
                            name={getLevelName(level)}
                            onClick={() => handleClick(level)}
                        />
                    </div>
                ))}
            </div>

        </section>
    );
};